import {Icon, view} from '@sail/ui';
import {useSelector} from 'src/v2/state/store';
import {
  getNetworkNameForLivemode,
  getNetworkIcon,
} from 'src/components/Wallet/constants';
import type {SupportedNetwork} from 'src/types';
import {Badge} from 'src/v2/components/common/Badge';
import {Text} from 'src/v2/components/common/Text';

interface Props {
  network: SupportedNetwork;
}

export const NetworkBadge = ({network}: Props) => {
  const livemode = useSelector((state) => state.livemode);

  return (
    <Badge>
      <view.div css={{stack: 'x', gap: 'xsmall', alignY: 'center'}}>
        <Icon
          icon={getNetworkIcon(network)}
          size="xsmall"
          css={{borderRadius: 'xsmall'}}
        />
        <Text type="caption" css={{color: 'inherit'}}>
          {getNetworkNameForLivemode(network, livemode)}
        </Text>
      </view.div>
    </Badge>
  );
};
